import { useState } from 'react'
import { Button, DotLoader, Modal, ParagraphText } from '@opallabs/lapidary'
import * as styles from './styles'
import type { AddToPlanModalProps, UseAddToPlanStateValue } from './types'

type FooterProps = Pick<AddToPlanModalProps, 'onCloseModal'> & {
  addToPlan: UseAddToPlanStateValue['actions']['addToPlan']
  momentCount: number
  updateDisabled: UseAddToPlanStateValue['validation']['updateDisabled']
}

export const Footer: React.FC<FooterProps> = ({
  addToPlan,
  momentCount,
  onCloseModal,
  updateDisabled,
}) => {
  const [updating, setUpdating] = useState(false)

  return (
    <Modal.Footer css={styles.footer}>
      <span>
        {momentCount > 1 && (
          <ParagraphText css={styles.selectionText}>
            {momentCount} items selected
          </ParagraphText>
        )}
      </span>
      <span css={styles.footerButtons}>
        <Button
          name="Cancel"
          variant="ghost"
          buttonText="Cancel"
          onClick={() => onCloseModal()}
        />
        <Button
          name="Update"
          css={{ inlineSize: 66 }}
          disabled={updating || updateDisabled}
          icon={updating ? <DotLoader /> : undefined}
          buttonText={updating ? undefined : 'Update'}
          variant="primary"
          onClick={() => {
            // A new instance is mounted each time the modal is opened
            // so that will reset this state to false for us since
            // addToPlan calls modal close callback
            setUpdating(true)
            addToPlan()
          }}
        />
      </span>
    </Modal.Footer>
  )
}
